import { Route, Routes } from 'react-router-dom'
import { NotFoundPage } from 'pages/not-found'
import MainLayout from 'features/main-layout'
import { NavigationPathes } from 'shared/constants'
import { WithdrawalsPage } from 'pages/withdrawals-page'
import { ReferralsWithdrawalsStatisticsPage } from 'pages/referrals-withdrawals-statistics-page'
import { CashbackWithdrawalsPage } from 'pages/cashback-withdrawals'
import { OffchainWithdrawalsPage } from 'pages/offchain-withdrawals'
import { UserAccountsPage } from 'pages/user-accounts'
import { GamesListPage } from '../pages/games-page'
import { SeasonsListPage } from '../pages/seasons-page'
import { BonusTemplatesPage } from '../pages/bonus-templates-page'

export const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route
          path={NavigationPathes.HOME}
          element={<>Welcome to Admin dashboard!</>}
        />

        <Route
          path={NavigationPathes.GAMES}
          element={<GamesListPage />}
        />

        <Route
          path={NavigationPathes.WITHDRAWALS}
          element={<WithdrawalsPage />}
        />

        <Route
          path={NavigationPathes.WITHDRAWALS_STATISTICS}
          element={<ReferralsWithdrawalsStatisticsPage />}
        />

        <Route
          path={NavigationPathes.CASHBACK_WITHDRAWALS}
          element={<CashbackWithdrawalsPage />}
        />

        <Route
          path={NavigationPathes.OFFCHAIN_WITHDRAWALS}
          element={<OffchainWithdrawalsPage />}
        />

        <Route
          path={NavigationPathes.REFERRAL_SEASONS}
          element={<SeasonsListPage />}
        />

        <Route
          path={NavigationPathes.BONUS_TEMPLATES}
          element={<BonusTemplatesPage />}
        />

        <Route
          path={NavigationPathes.USER_ACCOUNTS}
          element={<UserAccountsPage />}
        />

        <Route
          path='*'
          element={<NotFoundPage />}
        />
      </Route>
    </Routes>
  )
}
